import { _Web } from "../webs/types.js";
import { File } from "./types.js";
import { escapeQueryStrValue } from "../utils/escapeQueryStrValue.js";
_Web.prototype.getFileByServerRelativeUrl = function (fileRelativeUrl) {
    return File(this, "getFileByServerRelativeUrl('" + escapeQueryStrValue(fileRelativeUrl) + "')");
};
_Web.prototype.getFileByServerRelativePath = function (fileRelativeUrl) {
    return File(this, "getFileByServerRelativePath(decodedUrl='" + escapeQueryStrValue(fileRelativeUrl) + "')");
};
_Web.prototype.getFileById = function (uniqueId) {
    return File(this, "getFileById('" + uniqueId + "')");
};
_Web.prototype.getFileByUrl = function (fileUrl) {
    return File(this, "getFileByUrl('!@p1::" + escapeQueryStrValue(fileUrl) + "')");
};
//# sourceMappingURL=web.js.map